import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaWater, FaTools, FaWrench, FaCubes } from 'react-icons/fa';
import { useScrollAnimation } from '../../../ganchos/usarAnimacionScroll';
import { DataContext } from '../../../contexto/ContextoDatos';
import logoFull from '../../../recursos/imagenes/logo.webp';
import styles from './Servicios.module.css';

const ICONS = [
  <FaWater size={22} color="#fff" />,
  <FaTools size={22} color="#fff" />,
  <FaWrench size={22} color="#fff" />,
  <FaCubes size={22} color="#fff" />,
];

export const ServicesSection = () => {
  const [ref, visible] = useScrollAnimation({ threshold: 0.08 });
  const { services } = useContext(DataContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animatedOptions, setAnimatedOptions] = useState([]);

  useEffect(() => {
    const timers = services.map((_, i) =>
      setTimeout(() => setAnimatedOptions(prev => [...prev, i]), 180 * i)
    );
    return () => timers.forEach(clearTimeout);
  }, [services]);

  return (
    <section id="services" ref={ref} className={`${styles.seccion} ${visible ? styles.visible : ''}`}>
      <div className="container">
        <div className={styles.encabezado}>
          <h2 className={styles.tituloBloque}>
            <span className={styles.tituloTexto}>Servicios</span>
            <img src={logoFull} alt="SEIMA" className={styles.logoTitulo} />
          </h2>
          <div className={`${styles.lineaTitulo} ${visible ? styles.lineaVisible : ''}`} />
          <p className={styles.sub}>Soluciones industriales con tecnología de primer nivel.</p>
        </div>
      </div>

      <div className={styles.selectorWrapper}>
        {services.map((service, index) => (
          <div
            key={service.id}
            className={`${styles.panel} ${activeIndex === index ? styles.panelActive : ''}`}
            style={{
              backgroundImage: `url('${service.image}')`,
              backgroundSize: 'cover',
              opacity: animatedOptions.includes(index) ? 1 : 0,
              transform: animatedOptions.includes(index) ? 'translateX(0)' : 'translateX(-60px)',
              borderColor: activeIndex === index ? 'rgba(255,255,255,0.7)' : '#2a2a2a',
              boxShadow: activeIndex === index
                ? '0 20px 60px rgba(0,0,0,0.55)'
                : '0 8px 24px rgba(0,0,0,0.3)',
              flex: activeIndex === index ? '7 1 0%' : '1 1 0%',
              zIndex: activeIndex === index ? 10 : 1,
            }}
            onClick={() => setActiveIndex(index)}
          >
            <div className={styles.panelShadow} />

            {/* Left nav arrow */}
            {index > 0 && (
              <button
                className={styles.navArrow}
                style={{ left: '10px' }}
                onClick={(e) => { e.stopPropagation(); setActiveIndex(index - 1); }}
                aria-label="Servicio anterior"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
                  <polyline points="15,18 9,12 15,6" />
                </svg>
              </button>
            )}

            {/* Right nav arrow */}
            {index < services.length - 1 && (
              <button
                className={styles.navArrow}
                style={{ right: '10px' }}
                onClick={(e) => { e.stopPropagation(); setActiveIndex(index + 1); }}
                aria-label="Siguiente servicio"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
                  <polyline points="9,18 15,12 9,6" />
                </svg>
              </button>
            )}

            <div className={styles.panelLabel}>
              <div
                className={styles.panelIcon}
                style={{ animationDelay: `${index * 0.65}s` }}
              >
                {ICONS[index]}
              </div>
              <div className={styles.panelInfo}>
                <div
                  className={styles.panelTitle}
                  style={{
                    opacity: activeIndex === index ? 1 : 0,
                    transform: activeIndex === index ? 'translateX(0)' : 'translateX(25px)',
                  }}
                >
                  {service.name}
                </div>
                <div
                  className={styles.panelDesc}
                  style={{
                    opacity: activeIndex === index ? 1 : 0,
                    transform: activeIndex === index ? 'translateX(0)' : 'translateX(25px)',
                    transitionDelay: '0.05s',
                  }}
                >
                  {service.shortDescription}
                </div>
                <Link
                  to={`/servicios/${service.slug}`}
                  className={styles.panelBtn}
                  style={{
                    opacity: activeIndex === index ? 1 : 0,
                    transform: activeIndex === index ? 'translateX(0)' : 'translateX(25px)',
                    pointerEvents: activeIndex === index ? 'auto' : 'none',
                    transitionDelay: '0.1s',
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  Conoce más →
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={`container ${styles.ctaWrapper}`}>
        <Link
          to="/servicios"
          className={`btn btn-primary ${styles.ctaBtn}`}
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)', transition: 'opacity 0.6s ease 0.4s, transform 0.6s ease 0.4s' }}
        >
          Ver todos los servicios
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            strokeWidth={2} stroke="currentColor" width="18" height="18">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </Link>
      </div>
    </section>
  );
};
export default ServicesSection;
